import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Price from "@/pages/Price";
import FloorPlanPage from "@/pages/FloorPlanPage";
import Guide from "@/pages/Guide";
import ActionArea3 from "@/pages/ActionArea3";
import TwoBhk from "@/pages/TwoBhk";
import ThreeBhk from "@/pages/ThreeBhk";
import GatedCommunity from "@/pages/GatedCommunity";
import FlatsNearAA3 from "@/pages/FlatsNearAA3";
import LocationPage from "@/pages/LocationPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/vinayak-21-acres-price" element={<Price />} />
          <Route path="/vinayak-21-acres-floor-plan" element={<FloorPlanPage />} />
          <Route path="/best-property-in-new-town-kolkata" element={<Guide />} />
          <Route path="/properties-in-new-town-action-area-3" element={<ActionArea3 />} />
          <Route path="/2-bhk-flats-new-town-kolkata" element={<TwoBhk />} />
          <Route path="/3-bhk-flats-new-town-kolkata" element={<ThreeBhk />} />
          <Route path="/gated-community-properties-new-town-kolkata" element={<GatedCommunity />} />
          <Route path="/flats-near-new-town-action-area-3" element={<FlatsNearAA3 />} />
          <Route path="/vinayak-21-acres-location" element={<LocationPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
